import React from "react";
import { Link } from "@mui/material";

export const NewTabLink = (props) => (
  <Link href={props.href} rel="noreferrer" target="_blank">
    {props.children}
  </Link>
);
